<template>
  <div class="goods_index">
    <el-breadcrumb separator="/" slot="breadcrumb" class="breadcrumb-bg">
      <el-breadcrumb-item >首页</el-breadcrumb-item>
      <el-breadcrumb-item>商品价格</el-breadcrumb-item>
    </el-breadcrumb>
      <el-card class="box-card" style="margin-top: 15px">
          <el-form  :model="form">
              <el-form-item label="搜索">
                  <el-input size="medium" v-model="form.goods_title" placeholder="商品名称或货号" @input="search" style="width: 50%"></el-input>
              </el-form-item>



          </el-form>
      </el-card>
    <div class="header-top-15">
      <el-card class="box-card">
        <div class="page_box_num">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="totalpages"
            @current-change="changePage"
          >
          </el-pagination>
        </div>
      </el-card>
    </div>
    <div class="header-top-15">
      <el-card class="box-card">
        <el-button  type="primary" @click="batchDiscount">批量设置折扣</el-button>
        <el-button type="primary" @click="batchSwitch('y')">批量允许代理</el-button>
        <el-button type="danger" @click="batchSwitch('n')">批量取消代理</el-button>
          <el-button type="danger" @click="batchStock">设置批量库存</el-button>
      </el-card>
    </div>
    <el-table
      :data="result_data"
      stripe
      style="width: 100%; margin-top: 10px"
      @selection-change="handleSelectionChange"
      ref="multipleTable"
    >
      <el-table-column prop="id" label="ID" type="selection"> </el-table-column>
      <el-table-column  label="图片" width="100">

          <template slot-scope="scope">

              <img :src="scope.row.pic['url']" v-if="scope.row.pic!=''" style="width: 80px; height: 80px"/>
          </template>
      </el-table-column>
      <el-table-column prop="title" label="商品信息" width="180"> </el-table-column>
      <el-table-column label="总代价格" :tree-props="{ product_price: 'product_price' }">
        <template slot-scope="scope">
          <span v-if="scope.row.product_price.length > 0">
            {{ (scope.row.product_price[0].discount1 / 10 * scope.row.price).toFixed(2) }}
            {{ "(" + scope.row.product_price[0].discount[0] + "折" + ")" }}
          </span>
          <span v-else>
            {{ (result.agent_data.level1_discount / 10) * scope.row.price }}
            {{ "(" + result.agent_data.level1_discount + "折" + ")" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="市代价格" :tree-props="{ product_price: 'product_price' }">
        <template slot-scope="scope">
          <span v-if="scope.row.product_price.length > 0">
            {{ (scope.row.product_price[0].discount2 / 10 * scope.row.price).toFixed(2) }}
            {{ "(" + scope.row.product_price[0].discount[1] + "折" + ")" }}
          </span>
          <span v-else>
            {{ (result.agent_data.level2_discount / 10) * scope.row.price }}
            {{ "(" + result.agent_data.level2_discount + "折" + ")" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="区代价格" :tree-props="{ product_price: 'product_price' }">
        <template slot-scope="scope">
          <span v-if="scope.row.product_price.length > 0">

            {{(scope.row.product_price[0].discount3 / 10 * scope.row.price).toFixed(2)}}
          {{ "(" + scope.row.product_price[0].discount[2] + "折" + ")" }}

          </span>
          <span v-else>
            {{ (result.agent_data.level3_discount / 10) * scope.row.price }}
            {{ "(" + result.agent_data.level3_discount + "折" + ")" }}

          </span>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="价格"> </el-table-column>
      <el-table-column prop="cate" label="类别"> </el-table-column>
      <el-table-column prop="agent" label="代理权">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.agent"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="handleSwitch(scope.$index, scope.row)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="编辑">
        <template slot-scope="scope">

            <el-row type="flex" >
            <el-col :span="12">
                <el-button size="mini" type="primary" @click="setupStock(scope.$index, scope.row)"
                >设置库存</el-button >
            </el-col>
            <el-col :span="12">
                <el-button size="mini" @click="handleUpdate(scope.$index, scope.row)"
                >设置折扣</el-button>
            </el-col>
            <el-col :span="6"><div class="grid-content bg-purple"></div></el-col>
            </el-row>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="dialogFormVisible" custom-class="p_box_footer">
      <div slot="title">商品采购折扣</div>

      <el-form>
        <el-row>
          <el-col :span="6">
            <el-form-item label="省代">
              <el-input
                v-model="discount_price1"
                autocomplete="off"
                style="width: 9rem"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6"
            ><el-form-item label="市代">
              <el-input
                v-model="discount_price2"
                autocomplete="off"
                style="width: 9rem"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="6">
            <el-form-item label="区代">
              <el-input
                v-model="discount_price3"
                autocomplete="off"
                style="width: 9rem"
              ></el-input>
            </el-form-item>
          </el-col>
            <el-col :span="6">
                <el-button type="primary" @click="add_discount">折扣设置</el-button>
            </el-col>
        </el-row>

       <el-row>
              <el-col :span="6">
                  <el-form-item label="省价">
                      <el-input
                              v-model="price1"
                              autocomplete="off"
                              style="width: 9rem"
                      ></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="6"
              ><el-form-item label="市价">
                  <el-input
                          v-model="price2"
                          autocomplete="off"
                          style="width: 9rem"
                  ></el-input> </el-form-item
              ></el-col>
              <el-col :span="6">
                  <el-form-item label="区价">
                      <el-input
                              v-model="price3"
                              autocomplete="off"
                              style="width: 9rem"
                      ></el-input>
                  </el-form-item>
              </el-col>
             <el-col :span="6">
                 <el-button type="info" @click="add_price_discount" >价格设置</el-button>
             </el-col>
          </el-row>
      </el-form>

    </el-dialog>
    <el-dialog :visible.sync="dialogStoreVisible">
      <div slot="title">设置库存</div>
      <el-form label-width="100px">
        <el-row v-if="single" >
          <el-col
            ><p>商品名称：{{ product_stock.title }}</p></el-col
          >
        </el-row>

        <el-row>
          <el-col :span="10">
            <el-form-item label="设置库存">
              <el-input v-model="stock_qty" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5" style="padding-left: 10px">
            <el-button type="primary" @click="setupdateStock">确 定</el-button></el-col
          >
        </el-row>


      </el-form>

    </el-dialog>

    <el-dialog title="提示" :visible.sync="dialog_msg_visible" width="30%">
      <span>是否要取消</span>
      <span slot="footer">
        <el-button @click="dialog_msg_visible = false">取 消</el-button>
        <el-button type="primary" @click="dialog_msg_visible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
        form:{
            goods_title:"",
            type:'',
        },
      result_data:[],
      totalpages:0,
      multipleSelection: [],
      dialogFormVisible: false,
      dialogStoreVisible: false,
      single:true,
      stock_qty:0,
      price1: 0,
      price2: 0,
      price3: 0,
      discount_price1: 0,
      discount_price2: 0,
      discount_price3: 0,


      editeFlag: false,
      product_stock: {},

      dialog_msg_visible: false,
      page: 1,
      is_checked:false
    };
  },
  methods: {
    ...mapActions({
      getPriceDataAction: "getPriceDataAction",
      addProductPriceAction: "addProductPriceAction",
      GoodsAgentAction: "GoodsAgentAction",
      addStockAction:"addStockAction"
    }),

    handleEdit(index, row) {
      console.log(index, row);
      this.result["data"][index].editeFlag = true;
      //alert(row['id']);
      this.result["data"][index] = row;
    },
    handleUpdate(index, row) {
      this.message_discount(row);
      this.toggleSelection([row]);

      //alert(row['id']);
    },
    toggleSelection(rows) {

      if (rows) {
        rows.forEach((row) => {

          this.$refs.multipleTable.toggleRowSelection(row,true);
        });
      } else {

        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      console.log("tag", val);
      this.multipleSelection = val;
    },

      batchDiscount() {
      const len = this.multipleSelection.length;
      if (len == 0) {
        this.$message.error("请选择商品");
      } else {
        this.batch_message_discount([]);
      }
    },
      batch_message_discount() {


          this.dialogFormVisible = true;
      },
    message_discount(row) {
      if (row.product_price.length > 0) {
        this.discount_price1 = row.product_price[0].discount[0];
        this.discount_price2 = row.product_price[0].discount[1];
        this.discount_price3 = row.product_price[0].discount[2];
      } else {
        this.discount_price1 = 10;
        this.discount_price2 = 10;
        this.discount_price3 = 10;
      }

      this.dialogFormVisible = true;
    },
      //更新商品折扣
      add_price_discount() {

          let ids = [];
          this.multipleSelection.forEach((ele) => ids.push(ele.id));

          this.addProductPriceAction({
              price1: this.price1,
              price2: this.price2,
              price3: this.price3,
              ids: JSON.stringify(ids),
              type:"price"
          });

          this.multipleSelection = [];
          this.$refs.multipleTable.clearSelection();
          this.dialogFormVisible = false;
      },
    //更新商品折扣
    add_discount() {

      let ids = [];
      this.multipleSelection.forEach((ele) => ids.push(ele.id));

        this.addProductPriceAction({
            price1: this.discount_price1,
            price2: this.discount_price2,
            price3: this.discount_price3,
            ids: JSON.stringify(ids),
            type:"discount"
        });

      this.multipleSelection = [];
      this.$refs.multipleTable.clearSelection();
        this.dialogFormVisible = false;
    },
    //批量设置代理
    batchSwitch(type) {
      const len = this.multipleSelection.length;
      this.is_checked=false
      if (len == 0) {
        this.$message.error("请选择商品");
        return;
      }
      let status = 0;
      let ids = [];
      this.multipleSelection.forEach((ele) => ids.push(ele.id));

      if (type == "y") {
        status = 1;

        this.GoodsAgentAction({ status: status, ids: JSON.stringify(ids) });
      } else {
        status = 0;
        this.GoodsAgentAction({ status: status, ids: JSON.stringify(ids) });
      }
    },
    handleSwitch(index) {
      let status = 0;
      let ids = [];
      ids.push(this.result.data[index].id);
      if (this.result.data[index].agent == true) {
        status = 1;
        this.GoodsAgentAction({ status: status, ids: JSON.stringify(ids) });
      } else {
        status = 0;
        this.GoodsAgentAction({ status: status, ids: JSON.stringify(ids) });
      }
    },
    //更新库存
    setupdateStock() {
      this.dialogStoreVisible = false;
      console.log(this.product_stock);

        let ids = [];
        this.multipleSelection.forEach((ele) => ids.push(ele.id));

        this.addStockAction({
            stock_qty: this.stock_qty,

            ids: JSON.stringify(ids),
        });
        this.multipleSelection = [];
        this.$refs.multipleTable.clearSelection();
    },
      setPic(pic){

        return JSON.parse(pic)
      },
      batchStock(){

          const len = this.multipleSelection.length;
          if (len == 0) {
              this.$message.error("请选择商品");
              return
          }
          this.dialogStoreVisible = true;
          this.single=false
      },
    //设置库存
    setupStock(index, row) {
      this.dialogStoreVisible = true;
      this.product_stock = row;
        this.single=true
      this.toggleSelection([row])
      console.log(index, row);
    },
    changePage(e) {
      this.changePageData(e);
    },
    changePageData(page) {
      this.page = page;

      this.getPriceDataAction({ type: "post", page: page,title:this.form.goods_title });
    },
      search(){
          this.getPriceDataAction({ type: "post", page: 1,title:this.form.goods_title });
      },
      show_msg(text){

          this.$message({
              message: text,
              type: 'success'
          });
      }
  },

  mounted() {
    // this.myEcharts();

      this.getPriceDataAction({ type: "post", page: this.page,title:this.form.goods_title});
  },
  //tableData
  computed: {
    ...mapState({
      result: (state) => state.price.result,
      product_price:   (state) => state.product_price.result,
      stock: (state) => state.stock.result,
      purchase_order:  (state) => state.purchase_order.result,
    }),
  },
  watch: {
      purchase_order(newdata) {
        console.log(newdata)

        if(newdata.code==303 && !this.is_checked){


            this.getPriceDataAction({ type: "post", page: 1,title:this.form.goods_title});
            this.is_checked=true
            this.show_msg("设置成功")

        }


      },
    result(newdata, olddata) {
      console.log("result",newdata, olddata);

      if(newdata.code==200){

          this.result_data=newdata.data
          this.totalpages=newdata.totalpages
      }



    },
    product_price(newdata, olddata) {
          console.log(newdata, olddata);

          if (newdata.code == 305) {

              this.getPriceDataAction({ type: "post", page: 1,title:this.form.goods_title});
          }

      },
    stock(newdata, olddata) {
          console.log(newdata, olddata);

          if (newdata.code == 302) {
              this.show_msg("库存设置成功")
              this.getPriceDataAction({ type: "post", page: this.page,title:this.form.goods_title});
          }

      },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dialog-footer {
  text-align: center;
  background-color: gainsboro;
  padding: 0.3rem;
}
</style>
